const HUG_API_KEY = "apiKey";

/**
 * Get API Authentication token from LocalStorage
 */
const getApiToken = (): string | null =>
  window.localStorage.getItem(HUG_API_KEY);

/**
 * Set API Authentication token in LocalStorage
 */
const setApiToken = (token: string) =>
  window.localStorage.setItem(HUG_API_KEY, token);

/**
 * Delete API Authentication token in LocalStorage
 */
const deleteApiToken = () => window.localStorage.removeItem(HUG_API_KEY);

/**
 * Get cookie value by key
 */
const getCookie = (name: string): string | undefined => {
  const cookie = document.cookie
    .split("; ")
    .find((c) => c.startsWith(`${name}=`));
  return !cookie ? undefined : cookie.split("=")[1];
};

const DISCONNECT_PREFIX = "HUG_disconnected_";

/**
 * Determine if user has attempted to disconnect via our UI
 */
const getDisconnectedCookie = (connector: string): boolean =>
  !!getCookie(`${DISCONNECT_PREFIX}${connector}`);

/**
 * Save user's attempt to disconnect for future visits
 */
const setDisconnectedCookie = (connector: string) => {
  document.cookie = `${DISCONNECT_PREFIX}${connector}=true;max-age=${
    60 * 60 * 24 * 7
  }`;
};

/**
 * Remove user's disconnected status
 */
const deleteDisconnectedCookie = (connector: string) => {
  document.cookie = `${DISCONNECT_PREFIX}${connector}=false;max-age=0`;
};

type Preference = "SHOW_ADVANCED_FILTERS";

const preferenceKey = (key: Preference) => `HUG_PREFERENCE_${key}`;

/**
 * Get stored user preference from local storage
 */
const getPreference = (key: Preference) =>
  window.localStorage.getItem(preferenceKey(key));

/**
 * Set user preference in local storage
 */
const setPreference = (key: Preference, value: string) =>
  window.localStorage.setItem(preferenceKey(key), value);

/**
 * Delete user preference from local storage
 */
const deletePreference = (key: Preference) =>
  window.localStorage.removeItem(preferenceKey(key));

export {
  getApiToken,
  setApiToken,
  deleteApiToken,
  getCookie,
  getDisconnectedCookie,
  setDisconnectedCookie,
  deleteDisconnectedCookie,
  getPreference,
  setPreference,
  deletePreference,
};
